export default __webpack_public_path__ + "static/media/Search.2d116482.svg";